(function (app, ng) {

    app.provider("dashboardApi", [
        function () {
            this.$get = ["crmApiGateway", function (crmApiGateway) {
                var service = {};

                // GETs
                service.getDefaultDashboardTiles = () => {
                    return crmApiGateway.get(`/DashboardTiles`);
                };

                return service;
            }];
        }
    ]);

})(window.app, window.angular); // jshint ignore:line